import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Abuse,
  AbuseReasonValue,
  Exploitation,
  Lewd,
} from 'features/call/vrs-call-comments/enums';
import type { SelectItem } from 'features/ui/elements';

export const useVrsCallCommentsReasonOptions = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'abuseCommentText.reason',
  });

  const exploitationReasonOptions = useMemo<SelectItem[]>(
    () =>
      Object.values(Exploitation).map((value) => ({
        value,
        text: t(value),
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const lewdReasonOptions = useMemo<SelectItem[]>(
    () =>
      Object.values(Lewd).map((value) => ({
        value,
        text: t(value),
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const harassmentReasonOptions = useMemo<SelectItem[]>(
    () =>
      Object.values(Abuse).map((value) => ({
        value,
        text: t(value),
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const getReasonOptions = (commentReason: AbuseReasonValue): SelectItem[] => {
    const reasonOptions = {
      [AbuseReasonValue.EXPLOITATION]: exploitationReasonOptions,
      [AbuseReasonValue.LEWD]: lewdReasonOptions,
      [AbuseReasonValue.HARASSMENT]: harassmentReasonOptions,
    };

    return reasonOptions[commentReason];
  };

  return {
    getReasonOptions,
  };
};
